import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/FilterOption.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";

const NonCategoryFilterOption = ({
  filterOption,
  facetName,
  isMobile,
  mobileHandleFilterClick,
  isCurrentFilter,
  handleFilterClick,
}) => {
  // selected filter
  const selectedFilterClass = isCurrentFilter
    ? style.selectedFilter
    : style.unselectedFilter;
  const selectedFilterOptionContainer = isCurrentFilter
    ? style.selectedFilterOptionContainer
    : style.unselectedFilterOptionContainer;

  const handleClick = () => {
    filterOption.facet_name = facetName;

    if (isMobile) {
      mobileHandleFilterClick(filterOption);
    } else {
      handleFilterClick({ filter: filterOption });
    }
  };

  return isMobile ? (
    <li
      value={filterOption.id}
      className={`${selectedFilterOptionContainer} ${mobileStyle.filterOptionContainer}`}
      onClick={handleClick}
    >
      <div>{filterOption.name}</div>
      <img
        src="https://cdn-s3.touchofmodern.com/images/icons/icon_filterSelected%402x.png"
        className={`
          ${selectedFilterClass}
          ${style.multiSelectIcon}
        `}
      />
    </li>
  ) : (
    <div onClick={handleClick}>
      <li className={selectedFilterOptionContainer} value={filterOption.id}>
        <div
          className={`${style.filterOptionName} ${style.multiSelectFilterOptionName}`}
        >
          {filterOption.name}
        </div>
        <img
          src="https://cdn-s3.touchofmodern.com/images/icons/icon_filterSelected%402x.png"
          className={`${selectedFilterClass}
            ${style.multiSelectIcon}`}
        />
      </li>
    </div>
  );
};

NonCategoryFilterOption.propTypes = {
  filterOption: PropTypes.object.isRequired,
  facetName: PropTypes.string.isRequired,
  isCurrentFilter: PropTypes.bool.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
  mobileHandleFilterClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default NonCategoryFilterOption;
